import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class SmartCameraClustersService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	create(createData, callback) {
		const url = "/ecosystem/api/smartCameraClusters";
		const body = JSON.stringify(createData);
		this._restClient.exec_post(url, body, callback);
	}

	update(clusterId, update, callback) {
		const url = `/ecosystem/api/smartCameraClusters/${clusterId}`;
		const body = JSON.stringify(update);
		this._restClient.exec_put(url, body, callback);
	}

	delete(clusterId, callback) {
		const url = `/ecosystem/api/smartCameraClusters/${clusterId}`;
		this._restClient.exec_delete(url, callback);
	}

	getAll(callback) {
		const url = "/ecosystem/api/smartCameraClusters";
		this._restClient.exec_get(url, callback);
	}

	bulkDelete(data, callback) {
		const url = `/ecosystem/api/smartCameraClusters/bulkDelete`;
		const body = JSON.stringify(data);
		this._restClient.exec_put(url, body, callback);
	}
}
